import { render, staticRenderFns } from "./main-image-cmp.vue?vue&type=template&id=e7dc666c&scoped=true"
import script from "./main-image-cmp.vue?vue&type=script&lang=js"
export * from "./main-image-cmp.vue?vue&type=script&lang=js"
import style0 from "./main-image-cmp.vue?vue&type=style&index=0&id=e7dc666c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dc666c",
  null
  
)

export default component.exports